import { createFileRoute } from "@tanstack/react-router";
import NewsPost from "@/pages/NewsPost";
import { routeHead } from "@/lib/seo/route-head";
import { allowedNewsImage, DEFAULT_SITE_IMAGE } from "@/utils/newsImage";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/de/blog/stiri/$slug/")({
  loader: async ({ params }) => {
    const { data } = await supabase
      .from("news_posts")
      .select("slug, title, meta_title, meta_description, lead, category, published_at, created_at, updated_at, og_image_url")
      .eq("slug", params.slug)
      .eq("country", "DE")
      .maybeSingle();
    return { post: data ?? null };
  },
  head: ({ params, loaderData }) => {
    const base = routeHead("/de/blog/stiri/$slug/", params as Record<string, string>);
    const post = loaderData?.post;
    if (!post) return base;

    const url = `https://roautomarket.ro/de/blog/stiri/${post.slug}`;
    const description = post.meta_description || post.lead || "";
    const image = allowedNewsImage(post.og_image_url) ?? DEFAULT_SITE_IMAGE;

    return {
      ...base,
      meta: [
        ...base.meta,
        { property: "og:type", content: "article" },
        { property: "article:published_time", content: post.published_at || post.created_at || "" },
        { property: "og:image", content: image },
        { name: "twitter:image", content: image },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            headline: post.meta_title || post.title,
            description,
            image,
            datePublished: post.published_at || post.created_at,
            dateModified: post.updated_at || post.published_at || post.created_at,
            articleSection: post.category,
            author: {
              "@type": "Person",
              name: "RO Auto Market Redaktion",
              url: "https://roautomarket.ro/despre-noi",
            },
            publisher: {
              "@type": "Organization",
              name: "RO Auto Market",
              logo: {
                "@type": "ImageObject",
                url: "https://roautomarket.ro/og-roautomarket.png",
              },
            },
            mainEntityOfPage: { "@type": "WebPage", "@id": url },
          }),
        },
      ],
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <NewsPost />
  );
}
